// Type-safe query key factories
export const queryKeys = {
  users: {
    all: ['users'] as const,
    list: () => [...queryKeys.users.all, 'list'] as const,
  },
  recipes: {
    all: ['recipes'] as const,
    lists: () => [...queryKeys.recipes.all, 'list'] as const,
    details: () => [...queryKeys.recipes.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.recipes.details(), id] as const,
  },
  music: {
    all: ['music'] as const,
    lists: () => [...queryKeys.music.all, 'list'] as const,
    details: () => [...queryKeys.music.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.music.details(), id] as const,
  },
  stickers: {
    all: ['stickers'] as const,
    lists: () => [...queryKeys.stickers.all, 'list'] as const,
    details: () => [...queryKeys.stickers.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.stickers.details(), id] as const,
  },
  notes: {
    all: ['notes'] as const,
    lists: () => [...queryKeys.notes.all, 'list'] as const,
    details: () => [...queryKeys.notes.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.notes.details(), id] as const,
  },
  media: {
    all: ['media'] as const,
    urls: (keys: string[]) =>
      [...queryKeys.media.all, 'urls', ...keys] as const,
  },
} as const
